import React from "react"

import classnames from "classnames"
import { ReactSVG } from "react-svg"

import { images } from "@utils/imageUtils"

import "./index.scss"

const Checkbox = ({ checked, value, onChange, children }) => {
  return (
    <label className="checkbox-wrapper">
      <input
        type="checkbox"
        value={value}
        checked={checked}
        onChange={onChange}
      />
      <span
        className={classnames("checkbox", { "checkbox--active": checked })}
        // This element is purely decorative so we hide it for screen readers
        aria-hidden="true">
        {checked && (
          <ReactSVG src={images.ndCheckmarkCheckbox} className="checkmark" />
        )}
      </span>
      {children}
    </label>
  )
}

export default Checkbox
